var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandingGraphicQuoteLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 59",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.286%",
    y1: "27.345%",
    x2: "98.204%",
    y2: "73.228%",
    id: "landing_graphic_quote_left_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BCA7C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAF5F",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 54.752A4.23 4.23 0 004.248 59h24.307a4.23 4.23 0 004.247-4.248V30.208a4.23 4.23 0 00-4.247-4.248H14.159c0-6.608 5.192-11.8 11.8-11.8V0A25.885 25.885 0 000 25.96c0 .944 0 2.124.236 3.068C0 29.5 0 29.972 0 30.208v24.544zM51.445 59h24.307A4.23 4.23 0 0080 54.752V30.208a4.23 4.23 0 00-4.248-4.248H61.357c0-6.608 5.192-11.8 11.8-11.8V0a25.885 25.885 0 00-25.96 25.96c0 .944 0 2.124.237 3.068-.236.472-.236.944-.236 1.18v24.308c0 2.596 1.888 4.484 4.247 4.484z",
    fill: "url(#landing_graphic_quote_left_svg__a)",
    fillRule: "evenodd"
  })));
}

export default SvgLandingGraphicQuoteLeft;